module.exports = __webpack_public_path__ + "img/partnerHezuobg1.7c2c1691.png";